module.exports = __webpack_public_path__ + "static/media/StormSeer.e98b601d.png";